import styled from 'styled-components';

export const Description = styled.div<{ bold?: boolean }>`
  margin-top: 6px;
  padding: 0 30px;
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: ${(props) => (props.bold ? 'black' : '#4d4d4d')};
`;
